import React, { useState } from 'react';
import ThemeToggle from '../components/common/ThemeToggle';

export default function AuthLayout({ children, links, title = 'Vaš Tacho nalog', description = 'Pristup evidenciji i analizi aktivnosti vozača.' }) {
    return (
        <main className="auth-bg">
            <div className="auth-theme"><ThemeToggle /></div>
            <section className="auth-story" aria-label="Tacho Royal Team" style={{ '--auth-image': 'url(/images/background.jpg)' }}>
                <div className="auth-brand"><img src="/images/logo/tacho-logo.png" alt="" /><span>Tacho Royal Team</span></div>
                <div><span className="auth-eyebrow">VAŠ RADNI PROSTOR</span><h1>Jasan pregled.<br />Siguran korak dalje.</h1><p>Aktivnosti vozača, tahografski zapisi i izveštaji na jednom mestu.</p></div>
                <div className="auth-features"><span><i className="bi bi-speedometer2" aria-hidden="true" /> Taho čitač</span><span><i className="bi bi-person-vcard" aria-hidden="true" /> Vozači i vozila</span><span><i className="bi bi-file-earmark-text" aria-hidden="true" /> Izveštaji</span></div>
            </section>
            <section className="auth-card" aria-label={title}>
                <div className="auth-heading"><img className="logo" src="/images/logo/tacho-logo.png" alt="Tacho Royal Team" /><h2>{title}</h2><p>{description}</p></div>
                {children}
                {links && <div className="auth-links">{links}</div>}
            </section>
        </main>
    );
}

/** Polje forme prijave: greška se prikazuje kad korisnik napusti polje (dugme je onemogućeno dok forma nije ispravna). */
export function AuthField({ icon, error, children }) {
    const [left, setLeft] = useState(false);
    const show = left && !!error;
    const child = React.isValidElement(children) ? React.cloneElement(children, {
        'aria-label': children.props['aria-label'] || children.props.placeholder,
        'aria-invalid': show,
        onBlur: (e) => { setLeft(true); if (children.props.onBlur) children.props.onBlur(e); },
    }) : children;
    return (
        <div>
            <div className={`auth-input${show ? ' invalid' : ''}`}>
                <i className={`bi ${icon}`} aria-hidden="true" />
                {child}
            </div>
            {show && <small className="p-invalid-text auth-field-error" role="alert">{error}</small>}
        </div>
    );
}

/* kao Angular email validator: domen ne mora imati tačku (a@b je ispravno) */
export const EMAIL_RE = /^[^\s@]+@[^\s@]+$/;
export const EMAIL_ERR = 'E-mail adresa je obavezna i mora biti validna';
export const PASS_ERR = 'Lozinka je obavezna i mora sadržati minimum 8 karaktera i maksimum 50 karaktera';
export const validPass = (p) => !!p && p.length >= 8 && p.length <= 50;
